import React, {useState} from 'react';
import {MenuItem, Select} from '@material-ui/core';
import Panel from '../../../../../components/UI/DashboardPanel/Panel';
import {useTranslation} from 'react-i18next';
import styled from 'styled-components';
import {PanelTitle} from '../../../../../components/UI/DashboardPanel/PanelTitle';
import {harvest} from 'apps/web-portal-ui/src/app/config/const';
import SoilHealthSummaryPanel from './SoilHealthSummaryPanel';
import HarvestSummaryPanel from './HarvestSummaryPanel';
import {Props} from './types';

const SelectContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: -10px;
`;
const HarvestSoilHealthPanel = (props: Props) => {
  const {t} = useTranslation();
  const [window, setWindow] = useState<string>(harvest);
  const {isMobile} = props;
  const windowTitle = window === harvest ? t('dashboard.help.harvest') : t('navigation.accordion.vine.soil'); // Title of panel
  return (
    <Panel width="100%" right={!isMobile} height="420px">
      <PanelTitle>{`${windowTitle} ${t('dashboard.summary.overview')}`}</PanelTitle>
      <SelectContainer>
        <Select value={window} onChange={e => setWindow(e.target.value as string)}>
          <MenuItem value={harvest}>{t('dashboard.help.harvest')}</MenuItem>
          <MenuItem value="soil">{t('navigation.accordion.vine.soil')}</MenuItem>
        </Select>
      </SelectContainer>
      {window === harvest ? <HarvestSummaryPanel {...props} /> : <SoilHealthSummaryPanel {...props} />}
    </Panel>
  );
};

export default React.memo(HarvestSoilHealthPanel);
